module.exports = __webpack_public_path__ + "img/fluffy-pie.a0c6af84.jpg";